import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiUserPlus, FiUserCheck, FiClock } from 'react-icons/fi';
import { useToast } from '../../ToastContext';

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : 'http://localhost:8001/api';

/**
 * "Agregar como contacto" button shown on a creative's public profile.
 *
 * Props:
 *   targetUserId  – ID of the profile being viewed
 *   currentUser   – logged-in user object  ({ id, role, ... })
 *   token         – JWT auth token
 */
const AddContactButton = ({ targetUserId, currentUser, token }) => {
  const { addToast } = useToast();
  // status: 'loading' | 'hidden' | 'none' | 'pending' | 'contact'
  const [status, setStatus] = useState('loading');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token || !currentUser || !targetUserId) {
      setStatus('hidden');
      return;
    }
    const role = currentUser.role;
    if (!['creator', 'brand', 'admin'].includes(role) || currentUser.id === targetUserId) {
      setStatus('hidden');
      return;
    }

    axios
      .get(`${API}/contacts/check/${targetUserId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const s = res.data.status;
        setStatus(s === 'contact' || s === 'accepted' ? 'contact' : s);
      })
      .catch(() => setStatus('none'));
  }, [targetUserId, currentUser, token]);

  const handleAdd = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await axios.post(
        `${API}/contacts/request/${targetUserId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatus('pending');
      addToast({ type: 'success', title: 'Solicitud enviada', description: 'El creativo recibirá una notificación.' });
    } catch (err) {
      const msg = err?.response?.data?.detail || 'No se pudo enviar la solicitud';
      addToast({ type: 'error', title: 'Error', description: msg });
    } finally {
      setSubmitting(false);
    }
  };

  if (status === 'loading' || status === 'hidden') return null;

  if (status === 'contact') {
    return (
      <button type="button" className="pp-btn-add-contact pp-btn-add-contact--done" disabled>
        <FiUserCheck aria-hidden="true" /> Contacto
      </button>
    );
  }

  if (status === 'pending') {
    return (
      <button type="button" className="pp-btn-add-contact pp-btn-add-contact--pending" disabled>
        <FiClock aria-hidden="true" /> Solicitud enviada
      </button>
    );
  }

  return (
    <button
      type="button"
      className="pp-btn-add-contact"
      onClick={handleAdd}
      disabled={submitting}
    >
      <FiUserPlus aria-hidden="true" />
      {submitting ? 'Enviando…' : 'Agregar contacto'}
    </button>
  );
};

export default AddContactButton;
